module.exports = __webpack_public_path__ + "img/set2.3e9771d6.svg";